import { AuthService } from '@core/services/auth/auth.service';
import { catchError, filter, switchMap, take } from 'rxjs/operators';
import { BehaviorSubject, throwError } from "rxjs"; import { SpinnerVisibilityService } from 'ng-http-loader';
import { HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';

@Injectable()
export class HttpRefreshTokenInterceptor implements HttpInterceptor {
  constructor(
    private spinner: SpinnerVisibilityService,
    private auth: AuthService
  ) { }
  private refreshTokenInProgress = false;
  private refreshTokenSubject: BehaviorSubject<any> = new BehaviorSubject<any>(
    null
  );

  addAuthenticationToken(request) {
    const accessToken = this.auth.getToken();
    if (!accessToken) {
      return request;
    }
    return request.clone({
      setHeaders: {
        Authorization: `Bearer ${accessToken}`
      }
    });
  }
  intercept(request: HttpRequest<any>, next: HttpHandler): any {

    return next.handle(this.addAuthenticationToken(request)).pipe(
      catchError(error => {
        if (
          request.url.includes('token/RefreshToken') ||
          request.url.includes('WebAppUserAuthentication/CreateToken')
        ) {
          if (request.url.includes('token/RefreshToken')) {
            this.auth.logOut();
          }
          return throwError(error);
        }
        if (error.status !== 401) {
          return throwError(error);
        }
        if (this.refreshTokenInProgress) {
          return this.refreshTokenSubject.pipe(
            filter(result => result !== null),
            take(1),
            switchMap(() => next.handle(this.addAuthenticationToken(request)))
          )
        } else {
          this.refreshTokenInProgress = true;
          this.refreshTokenSubject.next(null);
          return this.auth.refreshToken().pipe(
            switchMap((tokenRefreshResponse: any) => {
              this.auth.saveToken(tokenRefreshResponse);
              this.refreshTokenInProgress = false;
              this.refreshTokenSubject.next(tokenRefreshResponse);

              return next.handle(this.addAuthenticationToken(request));
            }), catchError((error) => {
              this.refreshTokenInProgress = false;
              this.auth.logOut();
              this.spinner.hide();
              return throwError(error);
            })
          )
        }
      }));
  }
}
